import MdxPage from '@/components/mdx-page'
import Terms from './terms.mdx'

const TermsView = () => {
  return (
    <div className="container-sm pb-20 md:pb-30">
      <h2 className="py-8 text-center md:py-20">ONLIVE Studio利用規約</h2>
      <div className="bg-glass px-4 py-8 md:px-6 md:pt-10 md:pb-16">
        <MdxPage>
          <Terms />
        </MdxPage>
      </div>
    </div>
  )
}

export default TermsView
